module.exports = __webpack_public_path__ + "img/extract-qr-code.61c3ae16.jpg";